import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Layout, Icon, Row, Col, Affix } from 'antd';
import {
  NavigationHorizontale,
  NavigationVerticale,
  NavigationHomeEvidenceB,
} from './Navigation';
import Footer from './Footer';
import { StoreContext } from '../containers/Store';

import './Layout.css';
import ActivityDrawer from './ActivityDrawer';


const { Header, Sider, Content } = Layout;

const LayoutContainer = ({ children, ...props }) => {
  const { user: { user: authUser } } = useContext(StoreContext);
  const [collapsed, toggleCollapse] = useState((window.innerWidth < 520));
  
  useEffect(
    () => {
      window.addEventListener("resize", () => toggleCollapse((window.innerWidth < 520)));
      return () => {
        window.removeEventListener("resize", () => toggleCollapse((window.innerWidth < 520)));
      };
    },
    [window.innerWidth]
  );

  return (
      <Layout
        breakpoint={{ xs: '480px' }}
        style={{ minHeight: '100vh'}}
      >
        <Affix>
          <Header
            style={{
              padding: '0px',
              margin: '0px',
              backgroundImage:
              'linear-gradient(116deg, #C04C2A 0%, #C04C2A 100%)',
            }}>
            <Row
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '-2px',
              }}>
                <Col xxl={18} xl={18}  sm={16} xs={14} style={{height: '60px'}}>
                  <NavigationHomeEvidenceB />
                </Col>
                <Col xxl={6} xl={6} sm={8} xs={10} >
                  <NavigationHorizontale />
                </Col>
            </Row>
          </Header>
        </Affix>
      <Layout>
        { authUser && authUser.roles.length > 1 &&
          props.location.pathname !== '/' ? (<Sider
          width={200}
          style={{ background: '#fff' }}
          breakpoint="xs"
          trigger={null}
          collapsible
          collapsed={collapsed}
          >
          <NavigationVerticale />
          </Sider>) : null
        }
        <Layout style={{ padding: '0 24px 24px' }}>
          <Row>
            { authUser && authUser.roles.length > 1 &&
              props.location.pathname !== '/' &&  <Icon
              className="trigger"
              type={collapsed ? 'menu-unfold' : 'menu-fold'}
              onClick={() => toggleCollapse(!collapsed)}
            /> }
          </Row>
          <Content
            style={{
              padding: 0,
              margin: 0,
            }}>
            { children }
          </Content>
          <ActivityDrawer />
        </Layout>
      </Layout>
      <Affix>
        <Footer />
      </Affix>
    </Layout>
  );
}

export default withRouter(LayoutContainer);
